import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M3.98001 8.223C3.04446 9.32718 2.34782 10.6132 1.93401 12C3.22601 16.338 7.24401 19.5 12 19.5C12.993 19.5 13.953 19.362 14.863 19.105M6.22801 6.228C7.94065 5.09786 9.94809 4.49688 12 4.5C16.756 4.5 20.773 7.662 22.065 11.998C21.357 14.3673 19.837 16.4116 17.772 17.772M6.22801 6.228L3.00001 3M6.22801 6.228L9.87801 9.878M17.772 17.772L21 21M17.772 17.772L14.122 14.122C14.4006 13.8434 14.6216 13.5127 14.7724 13.1486C14.9232 12.7846 15.0008 12.3945 15.0008 12.0005C15.0008 11.6065 14.9232 11.2164 14.7724 10.8524C14.6216 10.4883 14.4006 10.1576 14.122 9.879C13.8434 9.6004 13.5127 9.3794 13.1487 9.22863C12.7846 9.07785 12.3945 9.00025 12.0005 9.00025C11.6065 9.00025 11.2164 9.07785 10.8524 9.22863C10.4884 9.3794 10.1576 9.6004 9.87901 9.879M14.121 14.121L9.88001 9.88",
      stroke: "currentColor",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1)
  ]))]))
}
export default { render: render }